/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentAgentScheduleRequest extends models.AiAgentScheduleRequest {
    constructor() {
        super();
        this.setDiscriminator("AssessmentAgentScheduleRequest");
    }

    getFixupPrototypeFunction() { return AssessmentAgentScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<AssessmentAgentScheduleRequest>): AssessmentAgentScheduleRequest {
        let obj = Object.assign(new AssessmentAgentScheduleRequest(), model);
        AssessmentAgentScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentAgentScheduleRequest>): AssessmentAgentScheduleRequest {
        if (!model) return null;
        return AssessmentAgentScheduleRequest.newInstance(<AssessmentAgentScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentAgentScheduleRequest) {
        if (!obj) return;

        models.AssessmentAgentScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentAgentScheduleRequest): boolean {
        if (models.AiAgentScheduleRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentAgentScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            models.ReportConfigurationForAiAgent.fixupPrototype(this.configuration);
        }
    }

    /**
     * Report configuration to generate report
     */
    configuration: models.ReportConfigurationForAiAgent;

}
